import React from "react";
import "../navbarstyles.css";

const backdrop = (props) => <div className="backdrop" onClick={props.click} />;

export default backdrop;
